import { IBooking, ITableItem } from 'shared-types/index';
import BookingLookupService from "external-services/booking-lookup-service";
import DateUtilsService from "external-services/date-utils-service";
import AdminService from "external-services/diary-admin-service/admin.service";

interface IConflict {
	firstBooking: IBooking,
	secondBooking: IBooking,
	overlapMins: number,
	table: ITableItem
}

const WORKER_FILE = 'webworkers/checkBookingConflicts.js'
class BookingConflictsService {
  private conflictWorker: Worker;
  private conflictBookingWorker: Worker;


  public _testSetConflictBookingWorker(worker: Worker) {
    this.conflictBookingWorker = worker;
  }

  /**
   * Given a date will find a schedule for that day
   * @param {Date} date
   */
  public async checkForConflicts(): Promise<IConflict[]> {
    if (!this.conflictWorker) {
      this.conflictWorker = new Worker(WORKER_FILE);
    }

    const venueTime = DateUtilsService.getVenueTime(AdminService.getVenueTimezoneId());
    // get the bookings
    BookingLookupService.getFromDate(venueTime).then((bookings: IBooking[]) => {
      // Send data to our worker.
      this.conflictWorker.postMessage(bookings);
    });

    // update the on message callback
    const checkConflictWorker = (): Promise<IConflict[]> => {
      return new Promise((resolve) => {
        this.conflictWorker.onmessage = (e: { data: IConflict[] }) => {
          resolve(e.data);
        };
      })
    }
    return checkConflictWorker()
  }

  public checkBookingsForConflicts(bookings: IBooking[]): Promise<IConflict[]> {
    if (!this.conflictBookingWorker) {
      this.conflictBookingWorker = new Worker(WORKER_FILE);
    }

    // Send data to our worker.
    this.conflictBookingWorker.postMessage(bookings);

    // update the on message callback
    const checkConflictBookingWorker = (): Promise<IConflict[]> => {
      return new Promise((resolve) => {
        this.conflictBookingWorker.onmessage = (e: { data: IConflict[] }) => {
          resolve(e.data);
        };
      })
    }
    return checkConflictBookingWorker()
  }
}
const instance = new BookingConflictsService();
export default instance as BookingConflictsService;
